(function ($, window, undefined) {

    var scene = document.getElementById('parallaxBox');
    if(scene){
        var parallax = new Parallax(scene);
    }

    var sceneInterno = document.getElementById('parralaxBoxInterno');
    if (sceneInterno) {
        var parallaxInternal = new Parallax(sceneInterno);
    }

    
    //Inicio interação envio de prospecção
    var validateEmail = function (email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }


    var sendFormProspeccao = function () {
        var loginData = { 'grant_type': 'password', 'username': 'sistema', 'password': 'proc14' };
        $.ajax({
            type: 'POST',
            crossDomain: true,
            url: 'https://integracao.advisebrasil.com.br/prospeccao/token',
            //url: 'http://localhost:33389/token',
            data: loginData,
            beforeSend: function () {
                $('#bottom-astronaut #box-now .step-btn').addClass('sending');
            }
        }).done(function (data) {

            tokenSeguros = data.access_token;
            console.log('Token: ' + tokenSeguros);

            // Dados do formulário
            var dataForm = {
                'Nome': $('#bottom-astronaut #box-now').find('input[name="nome"]').val(),
                'Email': $('#bottom-astronaut #box-now').find('input[name="email"]').val(),
                'Telefone': $('#bottom-astronaut #box-now').find('input[name="telefone"]').val(),

                'Origem': $('#bottom-astronaut #box-now').find('input[name="Origem"]').val(),
                'identificador': $('#bottom-astronaut #box-now').find('input[name="identificador"]').val()
            };

            $.ajax({
                url: 'https://integracao.advisebrasil.com.br/prospeccao/api/contato/cadastrarLeadSeguroBerkley',
                //url: 'http://localhost:33389/api/contato/cadastrarLeadSeguroBerkley',
                type: 'POST',
                data: dataForm,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', 'Bearer ' + tokenSeguros);
                    
                },
                success: function (data) {
                    if (data == 'Operação realizada com sucesso.') {

                        
                        $('#bottom-astronaut #box-now .step-btn').removeClass('sending');
                        $('.step-btn').after('<p class="success-msg-we-our">Obrigado pelo seu interesse. Em breve um de nossos consultores entrará em contato para apresentar o Advise Premium.</p>');

                        setTimeout(function () {
                            $('#bottom-astronaut #box-now .success-msg-we-our').fadeOut(function () {
                                $('#bottom-astronaut #box-now .success-msg-we-our').hide();
                            });
                        }, 10000);


                        fbq('track', 'Lead', {
                            content_name: dataForm.Nome,
                            content_category: 'Lead',
                            value: 69.90,
                            currency: 'BRL'
                        });

                        //Token d7ad0e96fa3a180769d57afa87b7ce3f
                        var TOKEN = 'd7ad0e96fa3a180769d57afa87b7ce3f'; // token de exemplo

                        var data_array = [
                          { name: 'email', value: dataForm.Email },
                          { name: 'telefone', value: dataForm.Telefone },
                          { name: 'identificador', value: dataForm.identificador },
                          { name: 'origem', value: dataForm.Origem },
                          { name: 'nome', value: dataForm.Nome },
                          { name: 'token_rdstation', value: TOKEN }
                        ];

                        RdIntegration.post(data_array);
                        console.log('beforeconv');
                        gtag_report_conversion();
                        console.log('afterconv');
                    }
                },
                error: function (data) {
                    $('.step-btn').after('<p class="success-msg-we-our red">Houve um problema com o envio</p>');

                    setTimeout(function () {
                        $('#bottom-astronaut #box-now .success-msg-we-our').fadeOut(function () {
                            $('#bottom-astronaut #box-now .success-msg-we-our').hide();
                        });
                    }, 2000);
                }
            });


        }).fail(function (error) {
            console.log('Error:' + error.responseText);
        });

        return false;
    }


    $('#bottom-astronaut #box-now input').on('keydown', function search(e) {
        if (e.keyCode == 13) {
            $('#bottom-astronaut #box-now .step-btn').click();
        }
    });




    $('#bottom-astronaut #box-now .step-btn').on('click', function () {

        if ($(this).hasClass('last-pass') && !$(this).hasClass('sending')) {
            sendFormProspeccao();
        }else{

            var box = $(this).closest('.input-box');
            if (box.find('input[type="text"]:visible').val() === '') {
                box.find('input[type="text"]:visible').addClass('animated flash');
                setTimeout(function () {
                    box.find('input[type="text"]:visible').removeClass('animated flash');
                
                },2000);
            } else {

                if ($('#box-now .input-box input:visible').prop('id') == 'email') {
                    if (validateEmail($('#box-now .input-box input:visible').val()) == false) {
                        
                        $('.step-btn').after('<p class="success-msg-we-our red">Informe um endereço de email válido</p>');

                        setTimeout(function () {
                            $('#bottom-astronaut #box-now .success-msg-we-our').fadeOut(function () {
                                $('#bottom-astronaut #box-now .success-msg-we-our').hide();
                            });
                        }, 2000);

                    } else {
                            $('#box-now .input-box input:visible').hide().next().show().focus();
                    }
                } else {
                    if ($('#box-now .input-box input:visible').prop('id') != 'telefone')
                    $('#box-now .input-box input:visible').hide().next().show().focus();
                }

            }

            if ($('#box-now .input-box input:visible').prop('id') == 'email') {
                $('#bottom-astronaut #box-now .step-btn').text('Começar é grátis!');
            } else if ($('#box-now .input-box input:visible').prop('id') == 'nome') {
                $('#bottom-astronaut #box-now .step-btn').text('Proximo');
            } else if ($('#box-now .input-box input:visible').prop('id') == 'telefone') {
                $('#bottom-astronaut #box-now .step-btn').addClass('last-pass').text('Enviar');
            }


        }

        return false;
    });

    


    //Fim prospecção


    $('#popup-form').on('hidden.bs.modal', function () {

        $('#popup-form, #popup-form2, #popup-form3').find("#content-form").show();
        $('#popup-form, #popup-form2, #popup-form3').find("#mensagem-form-success").hide();

    });

    if (window.location.hash == '#gratis30dias') {
        if ($('#popup-form3').length) {
            $('#popup-form3').modal('toggle');
        }
    }


    if (window.location.hash == '#teste7dias' || window.location.hash == '#teste15dias') {
        if($('#popup-form').length){
            $('#popup-form').modal('toggle');
        }
    }


    $('#formContato3').on('submit', function () {

        var formulariobox = $(this);

        // Dados do formulário
        var dataForm = {
            'Nome': $(formulariobox).find('input[name="Nome"]').val(),
            'Email': $(formulariobox).find('input[name="Email"]').val(),
            'Telefone': $(formulariobox).find('input[name="Telefone"]').val(),
            'Mensagem': $(formulariobox).find('input[name="Celular"]').val() + $(formulariobox).find('input[name="Email"]').val(),
            'OABNumero': $(formulariobox).find('input[name="Oab"]').val(),

            "Origem": $(formulariobox).find('input[name="Origem"]').val(),
            "identificador": $(formulariobox).find('input[name="identificador"]').val()
        };

        if (!dataForm.Nome && $(formulariobox).find('input[name="Nome"]').length) {
            $(formulariobox).find('.mensagem').addClass('error').html('Por favor preencha o campo nome').show();
        } else if (!dataForm.Email && $(formulariobox).find('input[name="Email"]').length) {
            $(formulariobox).find('.mensagem').addClass('error').html('Por favor preencha o campo e-mail').show();
        } else if (!dataForm.Telefone && $(formulariobox).find('input[name="Telefone"]').length) {
            $(formulariobox).find('.mensagem').addClass('error').html('Por favor preencha o campo telefone').show();
        } else if (!dataForm.Mensagem && $(formulariobox).find('input[name="Celular"]').length) {
            $(formulariobox).find('.mensagem').addClass('error').html('Por favor preencha o campo celular').show();
        } else if (!dataForm.OABNumero && $(formulariobox).find('input[name="Oab"]').length) {
            $(formulariobox).find('.mensagem').addClass('error').html('Por favor preencha o campo OAB').show();
        } else {




            var loginData = { 'grant_type': 'password', 'username': 'sistema', 'password': 'proc14' };
            $.ajax({
                type: 'POST',
                url: 'https://integracao.advisebrasil.com.br/prospeccao/token',
                //url: 'http://localhost:33389/token',
                data: loginData,
                beforeSend: function () {
                    formulariobox.find('button').text('Enviando...').addClass('sending').prop('disabled', true).css('opacity', '0.8');
                }
            }).done(function (data) {

                tokenSeguros = data.access_token;
                console.log('Token: ' + tokenSeguros);


                $.ajax({
                    url: 'https://integracao.advisebrasil.com.br/prospeccao/api/contato/cadastrarLeadSeguroBerkley',
                    //url: 'http://localhost:33389/api/contato/cadastrarLeadSeguroBerkley',
                    type: 'POST',
                    data: dataForm,
                    async:false,
                    beforeSend: function (xhr) {
                        xhr.setRequestHeader('Authorization', 'Bearer ' + tokenSeguros);
                    },
                    success: function (data) {
                        if (data == 'Operação realizada com sucesso.') {

                            $('.modal.fade.in').find('#content-form').fadeOut(function () {
                                $('.modal.fade.in').find('#mensagem-form-success').fadeIn();
                            });


                            //$('#formContato').find('.mensagem').removeClass('error').html('Em breve um consultor entrará em contato.').show();
                            formulariobox.find('button').text('Enviar').removeClass('sending').prop('disabled', false).css('opacity', '1');


                            //Token d7ad0e96fa3a180769d57afa87b7ce3f
                            var TOKEN = 'd7ad0e96fa3a180769d57afa87b7ce3f'; // token de exemplo

                            var data_array = [
                              { name: 'email', value: dataForm.Email },
                              { name: 'telefone', value: dataForm.Telefone },
                              { name: 'identificador', value: dataForm.identificador },
                              { name: 'origem', value: dataForm.Origem },
                              { name: 'nome', value: dataForm.Nome },
                              { name: 'token_rdstation', value: TOKEN }
                            ];

                            RdIntegration.post(data_array);


                        }
                    },
                    error: function (data) {
                        $(formulariobox).find('.mensagem').addClass('error').html('Ocorreu um erro na sua solicitação.').show();
                        formulariobox.find('button').text('Enviar').removeClass('sending').prop('disabled', false).css('opacity', '1');
                    }
                });


            }).fail(function (error) {
                console.log('Error:' + error.responseText);
            });
        }

        return false;
    });






    //formulario de teste
    $('#formContato, #formContato2').on('submit', function () {

        var formulariobox = $(this);

        // Dados do formulário
        var dataForm = {
            'Nome': $(formulariobox).find('input[name="Nome"]').val(),
            'Email': $(formulariobox).find('input[name="Email"]').val(),
            'Telefone': $(formulariobox).find('input[name="Telefone"]').val(),

            "Origem": $(formulariobox).find('input[name="Origem"]').val(),
            "Observacao": $(formulariobox).find('input[name="Observacao"]').val(),
            "identificador": $(formulariobox).find('input[name="identificador"]').val()
        };

        if (!dataForm.Nome) {
            $(formulariobox).find('.mensagem').addClass('error').html('Por favor preencha o campo nome').show();
        } else if (!dataForm.Email) {
            $(formulariobox).find('.mensagem').addClass('error').html('Por favor preencha o campo e-mail').show();
        } else if (!dataForm.Telefone) {
            $(formulariobox).find('.mensagem').addClass('error').html('Por favor preencha o campo telefone').show();
        } else {


        

        var loginData = { 'grant_type': 'password', 'username': 'sistema', 'password': 'proc14' };
        $.ajax({
            type: 'POST',
            url: 'https://integracao.advisebrasil.com.br/prospeccao/token',
            //url: 'http://localhost:33389/token',
            data: loginData,
            beforeSend: function () {
                formulariobox.find('button').text('Enviando...').addClass('sending').prop('disabled', true).css('opacity', '0.8');
            }
        }).done(function (data) {
            
            tokenSeguros = data.access_token;
            console.log('Token: ' + tokenSeguros);

            $.ajax({
                        url: 'https://integracao.advisebrasil.com.br/prospeccao/api/contato/cadastrarLeadSeguroBerkley',
                        //url: 'http://localhost:33389/api/contato/cadastrarLeadSeguroBerkley',
                        type: 'POST',
                        data: dataForm,
                        async:false,
                        beforeSend: function (xhr) {
                            xhr.setRequestHeader('Authorization', 'Bearer ' + tokenSeguros);
                        },
                        success: function (data) {
                            if (data == 'Operação realizada com sucesso.') {

                                $('.modal.fade.in').find('#content-form').fadeOut(function () {
                                    $('.modal.fade.in').find('#mensagem-form-success').fadeIn();
                                });


                                //$('#formContato').find('.mensagem').removeClass('error').html('Em breve um consultor entrará em contato.').show();
                                formulariobox.find('button').text('Enviado!').removeClass('sending').addClass('disabled').prop('disabled', true).css('opacity', '1');


                                //Token d7ad0e96fa3a180769d57afa87b7ce3f
                                var TOKEN = 'd7ad0e96fa3a180769d57afa87b7ce3f'; // token de exemplo

                                var data_array = [
                                  { name: 'email', value: dataForm.Email },
                                  { name: 'telefone', value: dataForm.Telefone },
                                  { name: 'identificador', value: dataForm.identificador },
                                  { name: 'origem', value: dataForm.Origem },
                                  { name: 'nome', value: dataForm.Nome },
                                  { name: 'token_rdstation', value: TOKEN }
                                ];

                                RdIntegration.post(data_array);


                            }
                        },
                        error: function (data) {
                            $(formulariobox).find('.mensagem').addClass('error').html('Ocorreu um erro na sua solicitação.').show();
                            formulariobox.find('button').text('Enviado!').removeClass('sending').addClass('disabled').prop('disabled', true).css('opacity', '1');
                        }
                });
          

                }).fail(function (error) {
                    console.log('Error:' + error.responseText);

                    // Por algum motivo os requests estão sendo enviados mas caindo no 'fail', apenas foi adicionado a mensagem para o usuário ver que foi enviado.
                    formulariobox.find('button').text('Enviado!').removeClass('sending').addClass('disabled').prop('disabled', true).css('opacity', '1');
                    $(formulariobox).closest('.modal').find('.content-form').fadeOut('fast', function () {
                        $(formulariobox).closest('.modal').find('.mensagem-form-success').fadeIn();
                    });
                });
        }
            
        return false;
    });


	(function () {
	    'use strict';


	    $('.btn-play').on('click', function (e) {
            if($(this).hasClass('rotate')){
                $(this).removeClass('rotate').siblings('#video-box').css('max-height', '0');
            } else {
                $(this).addClass('rotate').siblings('#video-box').css('max-height', '600px');
            }

	        return false;
	    });



	    $('.resource-item').on('mouseover click touchstart', function () {

	        //var imgPosition = $(this).attr('data-position'),
            //    imgActive = $('#imgAtual');

	        //imgActive.css('background-position', imgPosition);
	    });



		var $boxServicos = $('.box-servicos'),
			$boxServicosRow = $('.box-servicos .row'),
			$boxServicosUl = $('.box-servicos ul'),
			$boxServicosLi = $('.box-servicos ul li'),
			liQtd = $boxServicosLi.length;

		/*
		 * Função que seta o tamanho do LI do box de serviços
		 * O tamanho minimo da li é de 480
		 */
		var sizeServicos = function () {
			$boxServicosLi.css('overflow', 'hidden').addClass('animation');
			var sizeBlock = $boxServicosLi.eq(0).outerWidth();
			$boxServicosUl.width((liQtd) * sizeBlock);
		};

		$(window).load(function () {
			sizeServicos();
		});

		if (App.isMobile.any()) {
			$boxServicosRow.addClass('scroll-box');
		}

		document.addEventListener('touchstart', function () {

			$boxServicosLi.removeClass('animation');
		});

		document.addEventListener('touchend', function () {
			setTimeout(function () {
				$boxServicosLi.addClass('animation');
			}, 300);
		});

		$boxServicos.find('.prev').on('click', function () {
			var $boxServicosLiWidth = $boxServicosLi.eq(0).width(),
				leftPos = $boxServicosRow.scrollLeft();
			if ($boxServicosRow.scrollLeft() !== 0) {
				leftPos -= $boxServicosLiWidth;
				$boxServicosRow.animate({ scrollLeft: leftPos }, 300);
			}
		});

		$boxServicos.find('.next').on('click', function () {
			var $boxServicosLiWidth = $boxServicosLi.eq(0).width(),
				leftPos = $boxServicosRow.scrollLeft();
			if (($boxServicosUl.width() - $(window).width()) - $boxServicosRow.scrollLeft() !== 0) {
				leftPos += $boxServicosLiWidth;
				$boxServicosRow.animate({ scrollLeft: leftPos }, 300);
			}
		});

	}());



	//Intercom('onShow', function () {
	//    $("#intercom-container").css({'opacity': '1' , 'z-index' : '9999'});
        
	//});

	//Intercom('onHide', function () {
	//    $("#intercom-container").css({'opacity': '0', 'z-index' : '0'});
	//});


	//window._elev.on('widget:opened', function(_elev) {
	//    Intercom('hide');
	//});



}(jQuery, window));